import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { call as callEffect } from 'redux-saga/effects';
import { Project } from 'src/modules/common/types/Project';
import { prepareReportAttachment } from 'src/modules/report/sagas/utils/prepareReportAttachment';
import { ReportData } from 'src/modules/report/types/ReportData';
import { all } from 'typed-redux-saga';

export function* loadReportData(project: Project): SagaIterator<ReportData> {
  try {
    const { files } = project.data.report.appendix;
    const attachments = yield* all(files.map((file) => callEffect(prepareReportAttachment, file)));

    return { attachments };
  } catch (error) {
    throw new RuntimeError('Could not load report data', { project }, NativeError.wrap(error));
  }
}
